import React from 'react';
import { 
  HelpCircle, 
  PiggyBank, 
  Calculator, 
  TrendingDown, 
  Clock, 
  CreditCard, 
  FileText, 
  AlertCircle 
} from 'lucide-react';

/**
 * Компонент боковой панели с советами по досрочному погашению кредита
 */
const TipsSidebar = () => {
  const tips = [
    {
      icon: Calculator,
      title: 'Стратегия погашения',
      description: 'Для экономии процентов эффективнее уменьшать срок, для снижения финансовой нагрузки — уменьшать платеж.'
    },
    {
      icon: PiggyBank,
      title: 'Минимальная сумма',
      description: 'Большинство банков РФ устанавливают минимальную сумму досрочного погашения — обычно от 10 000 рублей.'
    },
    {
      icon: Clock,
      title: 'Оптимальный момент',
      description: 'Досрочное погашение наиболее выгодно в первой трети срока кредита, когда доля процентов максимальна.'
    },
    {
      icon: FileText,
      title: 'Заявление в банк',
      description: 'По закону РФ необходимо уведомить банк о досрочном погашении не менее чем за 30 дней для ипотеки и за 3-10 дней для потребительских кредитов.'
    },
    {
      icon: TrendingDown,
      title: 'Снижение переплаты',
      description: 'При досрочном погашении 20% суммы кредита в первый год можно сэкономить до 30-40% от общей переплаты.'
    },
    {
      icon: CreditCard,
      title: 'Рефинансирование',
      description: 'Если ставка по кредиту выше текущих рыночных на 2% и более, рассмотрите возможность рефинансирования.'
    },
    {
      icon: AlertCircle,
      title: 'Ограничения банков',
      description: 'Некоторые банки разрешают досрочное погашение только в даты платежей по кредиту.'
    }
  ];

  return (
    <div className="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 p-5 shadow-sm">
      <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <HelpCircle className="w-5 h-5 mr-2 text-green-500" />
        Советы по досрочному погашению
      </h3>

      <div className="space-y-3">
        {tips.map((tip, index) => (
          <div 
            key={index} 
            className="flex items-start space-x-3 p-3 bg-gray-50 dark:bg-gray-700/30 rounded-lg border border-gray-200 dark:border-gray-700 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
          >
            <tip.icon className="w-5 h-5 text-green-500 mt-1 flex-shrink-0" />
            <div>
              <h4 className="text-sm font-medium text-gray-900 dark:text-white mb-1">
                {tip.title}
              </h4>
              <p className="text-xs text-gray-600 dark:text-gray-400">
                {tip.description}
              </p>
            </div>
          </div>
        ))}
      </div>

      <div className="mt-6 p-4 bg-green-50 dark:bg-green-900/20 border border-green-100 dark:border-green-800 rounded-lg">
        <div className="flex items-start space-x-3">
          <HelpCircle className="w-5 h-5 text-green-500 mt-1 flex-shrink-0" />
          <div>
            <h4 className="text-sm font-semibold text-green-700 dark:text-green-300 mb-2">
              Закон о досрочном погашении
            </h4>
            <p className="text-xs text-green-600 dark:text-green-400 mb-3">
              В России действует закон №353-ФЗ "О потребительском кредите (займе)", 
              который гарантирует право заемщика на досрочное погашение кредита без дополнительных комиссий.
            </p>
            <a 
              href="http://www.consultant.ru/document/cons_doc_LAW_155986/" 
              target="_blank" 
              rel="noopener noreferrer"
              className="w-full inline-block py-1.5 text-center text-xs bg-green-500 text-white rounded hover:bg-green-600 transition-colors"
            >
              Подробнее о законе
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TipsSidebar;